import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { TiveSessionService } from './tive-session.service';

export const tiveHeadersInterceptorFn: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith('/api/')) {
    return next(req);
  }

  const session = inject(TiveSessionService);
  let headers = req.headers;

  // x-login-request is now injected by the proxy layer (URL-deterministic)

  // Attach user/account context for all API calls (when available)
  const userId = session.userId();
  const accountId = session.selectedAccountId();
  if (userId) {
    headers = headers.set('x-tive-user-id', userId);
  }
  // Only set account ID if not already present (allow per-request override)
  if (accountId != null && !headers.has('x-tive-account-id')) {
    headers = headers.set('x-tive-account-id', String(accountId));
  }

  return next(req.clone({ headers }));
};
